class PetFeature {
  constructor(el) {
    this.el = el;
    this.mq = window.matchMedia("(max-width: 767px)");
    if ($("." + this.el).length) this.event();
  }

  event() {
    document.querySelectorAll("." + this.el).forEach((root) => this.init(root));
  }

  getDirection() {
    return this.mq.matches ? "horizontal" : "vertical";
  }

  init(root) {
    const el = root.querySelector(".js-pet-feature-swiper");
    if (!el || typeof Swiper === "undefined") return;
    if (el.querySelectorAll(".swiper-slide").length < 2) return;

    const self = this;
    const swiper = new Swiper(el, {
      direction: this.getDirection(),
      slidesPerView: 1,
      speed: 600,
      autoHeight: false,
      watchOverflow: true,
      navigation: {
        nextEl: root.querySelector(".js-pet-feature-next"),
        prevEl: root.querySelector(".js-pet-feature-prev"),
      },
      pagination: {
        el: root.querySelector(".js-pet-feature-pagination"),
        clickable: true,
      },
    });

    const onMqChange = () => {
      const dir = self.getDirection();
      if (swiper.params.direction !== dir) swiper.changeDirection(dir);
    };

    if (this.mq.addEventListener) {
      this.mq.addEventListener("change", onMqChange);
    } else {
      this.mq.addListener(onMqChange);
    }
  }
}
